import { Bell, ShieldCheck, Ticket, Upload } from "lucide-react";

import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { PasswordField, PasswordRequirements } from "./password";

export default function AuthView({
  mode,
  setMode,
  loading,
  loginForm,
  setLoginForm,
  forgotPasswordForm,
  setForgotPasswordForm,
  resetPasswordForm,
  setResetPasswordForm,
  showLoginPassword,
  setShowLoginPassword,
  showResetPassword,
  setShowResetPassword,
  showResetPasswordConfirm,
  setShowResetPasswordConfirm,
  isResetPasswordFormValid,
  handleLogin,
  handleForgotPassword,
  handleResetPassword,
}) {
  return (
    <section className="support-hero">
      <div className="container support-hero-grid">
        <div>
          <div className="hero-announcement">
            <ShieldCheck className="w-4 h-4" />
            Support sécurisé
          </div>
          <h1 className="heading-1 mb-4">Espace client et gestion des tickets</h1>
          <p className="body-large">
            Connexion sécurisée, tickets par site, pièces jointes, suivi des statuts,
            reponses support et centre de notifications interne.
          </p>
          <div className="support-feature-list">
            <div><Ticket className="w-4 h-4" /> Tickets organises</div>
            <div><Upload className="w-4 h-4" /> Pieces jointes</div>
            <div><Bell className="w-4 h-4" /> Alertes internes</div>
          </div>
        </div>

        <Card className="support-auth-card">
          <CardHeader>
            <CardTitle className="heading-2">
              {mode === "login" && "Connexion"}
              {mode === "forgot" && "Mot de passe oublie"}
              {mode === "reset" && "Créer un nouveau mot de passe"}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {mode === "login" && (
              <form onSubmit={handleLogin} className="support-form-stack">
                <input className="form-input" type="email" placeholder="Email" value={loginForm.email} onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })} required />
                <PasswordField
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                  placeholder="Mot de passe"
                  required
                  isVisible={showLoginPassword}
                  onToggleVisibility={() => setShowLoginPassword((current) => !current)}
                />
                <p className="body-small support-auth-note">
                  Les accès clients sont créés par l'administration.
                </p>
                <button type="button" className="support-text-link" onClick={() => { setForgotPasswordForm({ email: loginForm.email }); setMode("forgot"); }}>
                  Mot de passe oublie ?
                </button>
                <Button type="submit" className="btn-primary w-full" disabled={loading}>
                  {loading ? "Connexion..." : "Se connecter"}
                </Button>
              </form>
            )}

            {mode === "forgot" && (
              <form onSubmit={handleForgotPassword} className="support-form-stack">
                <input className="form-input" type="email" placeholder="Email du compte" value={forgotPasswordForm.email} onChange={(e) => setForgotPasswordForm({ email: e.target.value })} required />
                <p className="body-small">Nous enverrons un lien de reinitialisation si le compte existe.</p>
                <Button type="submit" className="btn-primary w-full" disabled={loading}>
                  {loading ? "Envoi..." : "Recevoir un lien"}
                </Button>
                <button type="button" className="support-text-link" onClick={() => setMode("login")}>Retour a la connexion</button>
              </form>
            )}

            {mode === "reset" && (
              <form onSubmit={handleResetPassword} className="support-form-stack">
                {!resetPasswordForm.token && (
                  <p className="body-small support-auth-note">
                    Ouvre cette page depuis le lien de reinitialisation recu par email.
                  </p>
                )}
                <PasswordField
                  value={resetPasswordForm.new_password}
                  onChange={(e) => setResetPasswordForm({ ...resetPasswordForm, new_password: e.target.value })}
                  placeholder="Nouveau mot de passe"
                  required
                  isVisible={showResetPassword}
                  onToggleVisibility={() => setShowResetPassword((current) => !current)}
                />
                <PasswordField
                  value={resetPasswordForm.confirm_password}
                  onChange={(e) => setResetPasswordForm({ ...resetPasswordForm, confirm_password: e.target.value })}
                  placeholder="Confirmer le nouveau mot de passe"
                  required
                  isVisible={showResetPasswordConfirm}
                  onToggleVisibility={() => setShowResetPasswordConfirm((current) => !current)}
                />
                <PasswordRequirements
                  password={resetPasswordForm.new_password}
                  confirmPassword={resetPasswordForm.confirm_password}
                  showMatchCheck
                />
                <Button type="submit" className="btn-primary w-full" disabled={loading || !isResetPasswordFormValid}>
                  {loading ? "Réinitialisation..." : "Mettre à jour le mot de passe"}
                </Button>
                <button type="button" className="support-text-link" onClick={() => setMode("login")}>Retour a la connexion</button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
